import { JoinConversationPayload, SendChatMessagePayload } from '@/types/socket';
import { io, Socket } from 'socket.io-client';


class SocketService {
    private socket: Socket | null = null;

    connect() {
        if (!this.socket) {
            this.socket = io(`${process.env.REACT_APP_CHAT_SOCKET_URL}`, {
                path: '/chat/socket.io',
                transports: ['websocket', 'polling']
            });

            this.socket.on('connect', () => {
                console.log('Connected to socket server');
            });

            this.socket.on('disconnect', () => {
                console.log('Disconnected from socket server');
            });
        }
        return this.socket;
    }

    joinRoom(data:JoinConversationPayload) {
        if (this.socket) {
            this.socket.emit('join', data);
        }
    }

    setRole(data: { conversationId: string; role: string }) {
        if (this.socket) {
            this.socket.emit('set_role', data);
        }
    }

  setAnsweredBy(data: { conversationId: string; answeredBy: 'bot' | 'staff' | 'user' }) {
      if (this.socket) {
          this.socket.emit('set_answered_by', data);
      }
  }

    sendMessage(data:SendChatMessagePayload) {
        if (this.socket) {
            this.socket.emit('message', data);
        }
    }

    onMessage(callback: (data: any) => void) {
        if (this.socket) {
            this.socket.on('message', callback);
        }
    }

    onAgentJoined(callback: (data: any) => void) {
        if (this.socket) {
            this.socket.on('agent_joined', callback);
        }
    }

  onAgentLeft(callback: (data: any) => void) {
    if (this.socket) {
      this.socket.on('agent_left', callback);
    }
  }

  onUserJoined(callback: (data: any) => void) {
    if (this.socket) {
      this.socket.on('user_joined', callback);
    }
  }

  onUserLeft(callback: (data: any) => void) {
    if (this.socket) {
      this.socket.on('user_left', callback);
    }
  }

  onAnsweredByChanged(callback: (data: any) => void) {
      if (this.socket) {
          this.socket.on('answered_by_changed', callback);
      }
  }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
        }
    }
}

export const socketService = new SocketService();
